import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
      },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: "black",
    },
    formControl: {
        minWidth: '10%',
        minHeight:'90%',
        marginRight:'1rem',
        width:'36%'
    },
    tittlefont:{
        fontSize:'25px',
        margin:'1rem 1rem 1rem 0'
    },
    profile:{
        height:'136px', 
        width:'136px', 
        borderRadius:'50%', 
        border:'1px solid #F5F5F5', 
        backgroundColor:'#FFF6F2', 
        margin:'auto',
        textAlign:'center',
        marginBottom:'32px',
        marginTop:'20px'
    },
    profileInitials : {
        margin:'auto',
        height:'136px',
        marginTop:'35%',
        fontFamily:'Rubik',
        fontWeight:'300',
        fontSize :'40px',
        color : '#FE4500',
        opacity:0.25,
    },
    leadborder:{
        padding: '30px 20px 20px 20px',
        border:'1px solid #DFDFDF',
        marginTop:'1rem',
        borderRadius:'2px',
        // margin:'0 1rem 1rem 1rem',
    },
    profileicon:{
        zoom:'6',
        opacity:'0.5'
    },
    profilenameContainer:{
        textAlign:'center',
        margin:'auto !important'
    },
    profilename : {
        fontFamily:'Rubik',
        fontWeight:'500',
        fontSize :'20px',
        color : '#1D1D1D',
    },
    profileID :{
        fontFamily:'Rubik',
        fontWeight:'500',
        fontSize :'14px',
        color : '#1D1D1D',
    },
    profileCreatedOn : {
        fontFamily:'Rubik',
        fontWeight:'400',
        fontSize :'14px',
        color : '#2D2D2D',
    },
    star:{
        border: '1px solid #A2A2A2',
        paddingLeft:'2px',
        paddingRight:'2px',
        marginRight:'8px',
        position:'relative',
        top:'-2px'
    },
    datetime:{
        margin:'1rem 0 0 0',
        padding:'1rem 0 1rem 0',
        textAlign:'center',
        borderTop:'1px solid #DFDFDF',
        borderBottom:'1px solid #DFDFDF',
        display:'flex',
        alignItems:'center',
        justifyContent:'center'
    },
    fontleadbold:{
        fontFamily:'Rubik',
        fontWeight:'500',
        fontSize :'18px',
        color : '#1D1D1D',
        marginTop:'1rem',
        marginBottom:'1rem',
        paddingTop:'24px'
    },
    fontlead:{
        fontFamily:'Rubik',
        fontWeight:'500',
        fontSize :'16px',
        color : '#1D1D1D',
        marginTop:'1rem',
        marginBottom:'1rem'
    },
    fontanswer:{
        fontFamily:'Rubik',
        fontWeight:'400',
        fontSize :'16px',
        color : '#1D1D1D',
        marginTop:'1rem',
        marginBottom:'1rem'
    },
    leaddetails:{
        borderBottom:'2px dashed #DFDFDF',
        // opacity:'0.8'
    },
    CreateLeadmain:{
        overflow: 'hidden',
        width: '93%',
        margin: 'auto',
        height: '100%',
        backgroundColor: 'white',
    },
    createleadchiled:{
        padding: '20px 30px 20px 30px',
    },
    createlead:{
        display: 'flex',
    },
    container:{
        borderBottom:'1px solid #dfdfdf'
    },
    cancel:{
        fontFamily:'Rubik',
        fontWeight:'500',
        fontSize :'16px',
        border:'1px solid #FE4500',
        backgroundColor:'white',
        color:'#FE4500',
        marginTop:'20px',
        '&:hover':{
            backgroundColor:'white',
            opacity:'0.8'
        },
    },
    Upload:{
        border:'1px solid #FE4500',
        backgroundColor:'white',
        color:'#FE4500',
        fontSize:'14px',
        marginTop:'20px',
        width:'100%',
        paddingTop:'10px',
        paddingBottom:'10px',
        '&:hover':{
            backgroundColor:'white',
            opacity:'0.8'
        },
    },
    saveDownload:{
        border:'1px solid #FE4500',
        backgroundColor:'#FE4500',
        color:'white',
        marginTop:'20px',
        marginLeft:'20px',
        '&:hover':{
            backgroundColor:'#FE4500',
            opacity:'0.8'
        },
    },
    saveunder:{
        border:'1px solid #FE4500',
        backgroundColor:'#FE4500',
        color:'white',
        marginTop:'20px',
        float:'right',
        marginLeft:'20px',
        '&:hover':{
            backgroundColor:'#FE4500',
            opacity:'0.8'
        },
    },
    details:{
        margin:'0 1rem 1rem 1rem'
    },
    Administrative:{
        padding: '20px 20px 20px 20px',
        border:'1px solid #DFDFDF',
        marginTop:'1rem',
        borderRadius:'2px'
    },
    Uploadinstead:{
        padding: '20px 20px 20px 20px',
        border:'1px solid #DFDFDF',
        marginTop:'1rem',
        borderRadius:'2px'
    },
    add:{
        textDecoration:'none',
        marginRight:'5px'
    },
    Addstudent:{
        marginTop:'2rem',
        color:'#441514',
    },
    Addstudentp:{
        marginTop:'-1.2rem',
        marginLeft:'10px',
        textDecoration:'underline'
    },
    contectcolr:{
        fontFamily:'Rubik',
        fontWeight:'300',
        color:'#707070',
        fontSize:'16px',
        margin:'1rem 0 0 0',
    },
    contectstyle:{
        fontFamily:'Rubik',
        fontWeight:'400',
        color:'#1D1D1D',
        fontSize:'16px',
        margin:'1rem 0 0 0',
    },
    contectclor:{
        fontFamily:'Rubik',
        fontWeight:'400',
        fontSize:'12px',
        color:'#441514',
        margin:'1rem 0 0 0',
    },
    Ipm:{
        fontFamily:'Rubik',
        fontWeight:'500',
        color:'#441514',
        fontSize:'12px',
        textDecoration:'underline'
    },
    fontadmin:{
        color:'#1d1d1d',
        fontSize:'18px',
        fontFamily:'Rubik',
        fontWeight:'500'
    },
    homeText:{
        color:'#a2a2a2',
        fontFamily:'Rubik',
        fontWeight:'400',
        fontSize:'14px'
    },
    leadText : {
        color:'#1D1D1D',
        fontFamily:'Rubik',
        fontWeight:'400',
        fontSize:'14px'
    },
    rightArrow:{
        fontSize:'10px',
        marginTop:'4px',
        color:'#a2a2a2'
    },
    leadManagement:{
        color:'#1d1d1d',
        fontSize:'24px',
        fontFamily:'Rubik',
        fontWeight:'500'
    },
    insightsText:{
        fontFamily:'Rubik',
        fontWeight:'300',
        color:'#707070',
        fontSize:'16px'
    },
    titlefont:{
        margin:'1rem 1rem 1rem 0',
        color:'#1d1d1d',
        fontSize:'24px',
        fontFamily:'Rubik',
        fontWeight:'500'
    },
    contect:{
        marginTop:'-29px',
        opacity:'0.6',
        fontFamily:'Rubik',
        fontWeight:'300',
        color:'#707070',
        fontSize:'16px'
    },
    daysOld: {
        fontFamily:'Rubik',
        fontWeight:'400',
        color:'#1D1D1D',
        fontSize:'16px'
    },
    diamond:{
        marginLeft:'16px',
        marginRight:'16px'
    },
    docsContainer : {
        marginTop:'15px',
        marginBottom : '6px',
        width:'99%',
        marginLeft:'1px',
        fontSize:'16px',
        fontFamily:'Rubik',
        fontWeight:'400',
        borderRadius:'3px'
    },
    openmenu:{
        // marginTop:'-3rem',
        marginLeft:'-10%',
        boxShadow:'0px 0px 10px black',
        border:'1px solid #DFDFDF'
    },
    innermenu:{
        '&:hover':{
          backgroundColor:'#FFF6F2'
        },
    },
    inputNone:{
        display:'none'
    },
    validationText:{
        color:'#FE0053',
        fontFamily:'Rubik',
        fontWeight:'400',
        fontSize:'14px'
    },
    addNotesTitleContainer:{
        borderBottom:'1px solid #DFDFDF', 
        paddingBottom:'14px', 
        marginBottom:'24px'
    },
    addNotesYou : {
        color:'#1D1D1D',
        fontFamily:'Rubik',
        fontWeight:'500',
        fontSize:'14px'
    },
    addNotesDays :{
        color:'#707070',
        fontFamily:'Rubik',
        fontWeight:'400',
        fontSize:'14px'
    },
    addNotesContent:{
        color:'#707070',
        fontFamily:'Rubik',
        fontWeight:'300',
        fontSize:'16px'
    },
    addNotesBodyContainer:{
        borderBottom:'2px dashed #DFDFDF', 
        width:'99.9%', 
        marginLeft:'5px',
        marginBottom:'24px',
        paddingBottom:'12px'
    },
    taskDialogTitle:{
        color:'#1D1D1D',
        fontFamily:'Rubik',
        fontWeight:'500',
        fontSize:'20px',
        marginRight:'195px'
    },
    taskDialogQuestions:{
        color:'#1D1D1D',
        fontFamily:'Rubik',
        fontWeight:'400',
        fontSize:'14px'
    },
    taskDialogOptionSelected:{
        border:'1px solid #FE4500',
        color:'#FE4500',
        fontFamily:'Rubik',
        fontWeight:'500',
        fontSize:'14px',
        backgroundColor:'#FFF6F2',
        // paddingLeft:'16px',
        // paddingRight:'16px',
        // paddingTop:'13px',
        // paddingBottom:'13px',
        borderRadius:'4px',
        '&:hover':{
            cursor:'pointer'
        },
    },
    taskDialogOptionNotSelected:{
        border:'1px solid #DFDFDF',
        color:'#1D1D1D',
        fontFamily:'Rubik',
        fontWeight:'500',
        fontSize:'14px',
        // paddingLeft:'16px',
        // paddingRight:'16px',
        // paddingTop:'13px',
        // paddingBottom:'13px',
        borderRadius:'4px',
        '&:hover':{
            cursor:'pointer'
        },
    },
    leadid:{
        // margin: '-10px 0 0 0',
        width: '100%',
        color:'#FAF9F9',
        fontSize:'14px',
        fontFamily:'Rubik',
        fontWeight:'500'
        // border:'1px solid #DFDFDF',
        // borderRadius:'5px'
    },
    save:{
        fontFamily:'Rubik',
        fontWeight:'500',
        border:'1px solid #FE4500',
        backgroundColor:'#FE4500',
        color:'white',
        marginRight:'20px',
        marginTop:'-10px',
        marginBottom:'10px',
        '&:hover':{
            backgroundColor:'#FE4500',
            opacity:'0.8'
        },
    },
    plusHover:{
        '&:hover':{
            cursor:'pointer'
        }
    },
    validationContainer : {
        border:'1px solid #FE0053',
        borderRadius:'4px', 
        marginRight:'20px',
        // padding:'5px'
    },
    uploadConvertedDocName:{
        fontFamily:'Rubik',
        fontWeight:'400',
        fontSize:'16px',
        position:'relative',
        top:'-7px'
    },
    downloadCSVSelected: {
        fontFamily: 'Rubik',
        fontWeight: '400',
        border: '1px solid #DFDFDF',
        zoom: '0.8',
        margin: '13px 0 0 0',
        boxShadow: 'none',
        color: '#ffffff',
        backgroundColor: '#FE4500',
        position: 'relative',
        left: '10px',
        '&:hover': {
            color: '#ffffff',
            backgroundColor: '#FE4500'
        },
    },
    hotTagContainer:{
        background:"#F2B705",
        borderRadius:'1px',
        height:'19px',
        width:'38px',
        padding:'0px 2px 4px 4px',
        marginLeft:'16px',
        position:'relative',
        top:'-3px'
    },
    hotTagText:{
        fontFamily: 'Rubik',
        fontSize: '12px',
        fontWeight: '400',
        color: '#FFFFFF',
        letterSpacing:'3px',
    },
    dropdownText:{
        fontFamily: 'Rubik',
        fontSize: '14px',
        fontWeight: '500',
    },
    containerMargin:{
        margin: "0 1rem 1rem 1rem",
        width:'96%'
    },
    platformContainer:{
        background:'#FFF6F2',
        padding:'8px 16px 8px 16px',
        fontFamily: 'Rubik',
        fontSize: '14px',
        fontWeight: 'bold',
        width:'90%',
        borderRadius:'4px',
        marginBottom:'28px',
        marginTop:'13px',
    },
    shareLinkText:{
        color:'#FE4500',
        textDecoration:'underline',
        '&:hover':{
            cursor:'pointer'
        },
    },
    appointmentScroller:{
        borderRadius:'13px',
        backgroundColor:'black',
        margin:'4px'
    },
    appointName:{
        fontFamily: 'Rubik',
        fontSize: '16px',
        fontWeight: '500',
    },
    appointDate:{
        fontFamily: 'Rubik',
        fontSize: '12px',
        fontWeight: '400',
    },
    appointmentDialogTitle:{
        background:'#7553E8',
        borderRadius:'13px',
        color:'white',
        fontFamily: 'Rubik',
        fontSize: '10px',
        fontWeight: '400',
        padding:'5px 10px 5px 10px',
        marginTop:'5px'
    },
    appointmentDialogName:{
        fontFamily: 'Rubik',
        fontSize: '18px',
        fontWeight: '500',
        color:'black'
    },
    appointmentBranchContainer:{
        border: '1px solid #EAEAEA',
        borderRadius:'8px',
        padding:'16px'
    },
    appointmentBranchFirstSubContainer:{
        borderBottom:'1px solid #EAEAEA',
        paddingBottom:'16px'
    },
    appointmentBranchMidSubContainer:{
        borderBottom:'1px solid #EAEAEA',
        paddingTop:'16px',
        paddingBottom:'16px'
    },
    appointmentBranchLastSubContainer:{
        paddingTop:'16px'
    },
    appointmentBranchText:{
        fontFamily: 'Rubik',
        fontSize: '14px',
        fontWeight: '400',
        color:'#707070'
    },
    appointmentBranchName:{
        fontFamily: 'Rubik',
        fontSize: '14px',
        fontWeight: '400',
        color:'#1D1D1D'
    },
    appointmentBranchDate:{
        fontFamily: 'Rubik',
        fontSize: '14px',
        fontWeight: '500',
        color:'#1D1D1D'
    },
    appointmentBranchReschedule:{
        fontFamily: 'Rubik',
        fontSize: '14px',
        fontWeight: '500',
        color:'#FE4500'
    },
    appointmentCancelText:{
        fontFamily: 'Rubik',
        fontSize: '14px',
        fontWeight: '500',
        color:'#FE4500',
        textDecoration:'underline'
    },
    appointmentNotesText:{
        fontFamily: 'Rubik',
        fontSize: '18px',
        fontWeight: '500',
        color:'black',
        marginTop:'32px',
        marginBottom:'24px'
    },
    appointmentMarkButton:{
        textTransform: 'none', 
        width:'90%', 
        marginBottom:'40px', 
        fontWeight: '500',
        fontSize: '16px',
    },
    fixedHeightScroller:{
        maxHeight:'200px',
        overflowY:'scroll'
    }
}));

export default useStyles